namespace Nobox {
    
    @Serenity.Decorators.registerEditor()
    export class InputTypeEditor extends Serenity.Select2Editor<object, object> {

        constructor(hidden: JQuery) {
            super(hidden, null);
            this.addItem({ id: "text", text: "Text" });
            this.addItem({ id: "date", text: "Date" });
            this.addItem({ id: "time", text: "Time" });
            this.addItem({ id: "number", text: "Number" });
            this.addItem({ id: "email", text: "Email" });
            this.addItem({ id: "url", text: "URL" });
            this.addItem({ id: "radio", text: "Radio" });
            this.addItem({ id: "checkbox", text: "Checkbox" });
            this.addItem({ id: "file", text: "Single File" });
            this.addItem({ id: "fileMulti", text: "Multiple File" });
        }
    }
}